// extracted by css-extract-rspack-plugin
export default {"anchor":"VersionSelector-module__anchor__gix_Q"};